<template>
  <div
    id="vue-gf-beneficiary-search"
    class="container px-0 mb-4"
  >
    <GfCharity
      :event-campaign-id="eventCampaignId > 0 ? eventCampaignId.toString() : ''"
      :beneficiary-id="beneficiaryIdToPass"
      :allow-preselection-change="allowPreselectionChangeSettings"
      :ignore-event-tiering="ignoreEventTiering"
      :region="region ? region.toUpperCase() : region"
      :after-select-call-back="afterSelectCallBack"
      :after-reset-call-back="afterResetCallBack"
      :external="external"
      :mode="mode"
      :config="getConfig"
      :tag-ids-as-csv="tagIdsAsCsv"
      :show-more-results-info-text="showMoreResultsInfoText"
      :paging-settings="pagingSettings"
      @reset="reset"
      @selected="selected"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { VueLoggerPlugin } from "@gf/gf-logger";
import VueScrollTo from "vue-scrollto";
import BeneficiaryServicePlugin from "./components/inc/BeneficiaryServicePlugin";
import EventServicePlugin from "./components/inc/EventsServicePlugin";
import GfCharity from "./components/GfCharity";
import WowJs from "wowjs";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faTimesCircle,
    faCheckCircle,
} from "@fortawesome/free-regular-svg-icons";
import vueDebounce from "vue-debounce";

library.add(faTimesCircle);
library.add(faCheckCircle);

Vue.use(VueLoggerPlugin);
Vue.use(vueDebounce);

export default {
    components: { GfCharity },

    props: {
        eventCampaignId: {
            type: Number,
            default: 0,
        },
        beneficiaryId: {
            type: Number,
            default: 0,
        },
        region: {
            type: String,
            default: "",
        },
        apiDomain: {
            type: String,
            default: "",
        },
        afterSelectCallBack: {
            type: String,
            default: "",
        },
        afterResetCallBack: {
            type: String,
            default: "",
        },
        external: {
            type: Object,
            default: () => {},
        },
        mode: {
            type: Object,
            default: () => {
                return {
                    name: "beneficiaryCard",
                    settings: {},
                };
            },
        },
        config: {
            type: Object,
            default: () => {},
        },
        tagIdsAsCsv: {
            type: String,
            default: "",
        },
        allowPreselectionChange: {
            type: Boolean,
            default: false,
        },
        ignoreEventTiering: {
            type: Boolean,
            default: false,
        },
        showMoreResultsInfoText: {
            type: Boolean,
            default: true,
        },
        pagingSettings: {
            type: String,
            default: "infinite",
        },
        disableAutoFocus: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            beneficiaryIdToPass: this.beneficiaryId,
            allowPreselectionChangeSettings: this.allowPreselectionChange,
            defaultConfig: {
                otherCharitiesTitle: "Other",
                tieredRefineSearchText:
                    "More charities may be available, try entering a search text",
                tooManyResultsText:
                    "Looks like there's too many results, try refining your search",
                noResultsText:
                    "Can't see your charity here? Email support@gofundraise.com to nominate your charity.",
                disableSelectOnSingleCharity: false,
            },
        };
    },
    computed: {
        getConfig() {
            return Object.assign(this.defaultConfig, this.config);
        },
    },
    async mounted() {
        this.$gfLogger.logInfo("Mounted GfBeneficiarySearch");
        this.scrollToComponent();
        if (this.eventCampaignId && this.eventCampaignId > 0 && this.beneficiaryId == 0)
            await this.setBeneficiaryIfSingleBeneficiary();
    },
    created: function () {
        this.setupServicePlugins();
    },

    methods: {
        setupServicePlugins() {
            var servicePluginOptions = {
                apiDomain: this.apiDomain,
                region: this.region ? this.region.toUpperCase() : this.region,
            };

            Vue.use(BeneficiaryServicePlugin, servicePluginOptions);
            Vue.use(EventServicePlugin, servicePluginOptions);
        },

        async setBeneficiaryIfSingleBeneficiary() {
            var eventSearchResult = await this.$eventsService.searchWithParams({ eventcampaignid: this.eventCampaignId, pagesize: 1 })
            if (eventSearchResult.data && eventSearchResult.data.Events && eventSearchResult.data.Events.length === 1 && eventSearchResult.data.Events[0].IsMultiCharity)
                return;
            var result = await this.$beneficiaryService.searchByEvent(this.eventCampaignId)
            if (result.data && result.data.Beneficiaries && result.data.Beneficiaries.length === 1) {
                this.beneficiaryIdToPass = parseInt(result.data.Beneficiaries[0].BeneficiaryAccountId)
                this.allowPreselectionChangeSettings = false;
                this.$gfLogger.logInfo(`using BeneficiaryId: ${this.beneficiaryIdToPass}`)
            }
        },

        scrollToComponent() {
            if (this.disableAutoFocus) return;

            this.$emit("scrollToComponent", true);
            setTimeout(() => {
                VueScrollTo.scrollTo("#vue-gf-beneficiary-search", "100", {
                    easing: "ease-in",
                    offset: -60,
                    force: true,
                });
            }, 1000);
        },

        reset(paramValues) {
            this.$emit("reset", paramValues);
        },

        selected(paramValues) {
            this.$emit("selected", paramValues);
        },
    },
};
</script>
<style lang="scss">
#vue-gf-beneficiary-search {
    @import "bootstrap/scss/bootstrap";
}

#vue-gf-beneficiary-search {
    font-family: "bariol_regularregular";
}
</style>
